export class Ingredient {

  static units: string[] = [
    "l",
    "dl",
    "cl",
    "ml",
    "g",
    "gr",
    "gram",
    "kilo",
    "kilogram",
    "kg",
    "tak",
    "takken",
    "takjes",
    "el",
    "eetlepel",
    "eetlepels",
    "soeplepel",
    "koffielepel",
    "koffielepels",
    "stuk",
    "stukken",
    "stuks",
    "bussel",
    "bussels",
    "schel",
    "schellen"
  ];

  amount: number;
  unit: string;
  name: string;

  constructor(obj: {
    amount?: number,
    unit?: string,
    name?: string
  }) {
    this.amount = obj.amount || null;
    this.unit = obj.unit || null;
    this.name = obj.name || '';
  }

  static parseIngredient(ingredient: string): Ingredient {
    let parsed = new Ingredient({});
    let split = ingredient.split(' ')
      .map(value => value.toLowerCase());
    if (split.length > 1 && !isNaN(Number(split[0]))) {
      parsed.amount = Number(split[0]);
      split.splice(0, 1);
    }
    if (split.length > 1 && this.units.indexOf(split[0]) != -1) {
      parsed.unit = split[0];
      split.splice(0, 1);
    }
    parsed.name = split.join(' ');
    return parsed;
  }

}
